import React, { FC } from 'react';
import { CSVLink } from 'react-csv';
import { DownloadIcon } from '@heroicons/react/outline';

import { VisitorView } from 'src/editor/insights/constants';
import { TooltipComponent } from 'src/common/tooltip/component';
import { formatDuration } from 'src/utils/date';

interface CSVDownloadProps {
  data?: VisitorView[];
}

export const CSVDownload: FC<CSVDownloadProps> = ({ data }) => {
  if (!data) return null;
  const dataToDownload = data?.map(({ visitor, created_at, duration, completed_percentage, device_type }) => {
    const personData = visitor?.clearbit_data?.person;
    const companyData = visitor?.clearbit_data?.company;
    return {
      viewed: created_at,
      time_spent: formatDuration(duration),
      completion: `${Math.round(completed_percentage)}%`,
      device: device_type?.os || null,
      bio: personData?.bio || null,
      city: personData?.geo?.city || null,
      employment: personData?.employment?.title || null,
      linkedin: personData?.linkedin?.handle || null,
      company_emailAddresses: companyData?.site?.emailAddresses?.map((email) => email).join(', ') || null,
      company_industry_group: companyData?.category?.industryGroup || null,
      company_industry: companyData?.category?.industry || null,
      company_tags: companyData?.tags?.join(', ') || null,
      company_description: companyData?.description || null,
      company_founded_year: companyData?.foundedYear || null,
      company_geo_city: companyData?.geo?.city || null,
      company_linkedin: companyData?.linkedin?.handle || null,
      company_crunchbase: companyData?.crunchbase?.handle || null,
      company_email_provider: companyData?.emailProvider || null,
      company_type: companyData?.type || null,
      company_metrics_employeesRange: companyData?.metrics?.employeesRange || null,
      company_metrics_raised: companyData?.metrics?.raised || null,
      company_metrics_annualRevenue: companyData?.metrics?.annualRevenue || null,
      company_tech: companyData?.tech?.join(', ') || null,
    };
  });
  return (
    <div className='flex justify-end'>
      <TooltipComponent placement='left' tooltipContent={'Download CSV, included company data'}>
        <CSVLink data={dataToDownload} className='flex flex-row' filename='journey-visitors-data.csv'>
          <DownloadIcon height={20} />
        </CSVLink>
      </TooltipComponent>
    </div>
  );
};
